<template>
  <naj-modal
    ref="caseReconciliationAttachments"
    :width="1500"
    :footer="true"
    :close-button="true"
    :show-footer-close-button="true"
    @onClose="closeCaseReconciliationAttachments"
  >
    <v-row>
      <div class="preview-holder">
        <div
          v-if="loading"
          class="loader-holder"
        >
          <naj-loader></naj-loader>
        </div>
        <template v-else>
          <div
            v-if="document"
            class="attachment-file-viewer pdf-file"
          >
            <div
              v-if="selectedReconciliationAttachment.DocumentID"
              class="pdf-container"
            >
              <div class="pdf-wrapper">
                <div class="pdf-holder">
                  <embed :src="fileUrl">
                </div>
              </div>
            </div>
            <p
              v-else
              class="document-text"
            >
              {{ document }}
            </p>
          </div>
        </template>
      </div>
    </v-row>

    <template
      slot="actions"
      slot-scope="{ closeNajModal }"
    >
      <span class="attachment-wrapper">
        <naj-button
          v-for="(recAttachment ,index) in attachmentList"
          :key="index"
          @click="getAttachmentDocument(recAttachment)"
        >
          {{ local.lawsuitRequest.reconciliationInfo.reconciliationFile }} {{ recAttachment.AttachName }}
        </naj-button>
      </span>
    </template>
  </naj-modal>
</template>

<script>
import { getBlobUrl } from '@/modules/lawsuit/helpers/utils';

import { createNamespacedHelpers } from 'vuex';
const { mapActions: mapCasesActions } = createNamespacedHelpers('CasesModule');

export default {
  name: 'ReconciliationAttachmentsModal',
  props: {
    caseModel: { type: Object },
    modalVisibility: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      attachmentList: [],
      loading: false,
      document: null,
      selectedReconciliationAttachment: null,
    };
  },
  computed: {
    fileUrl() {
      return getBlobUrl(this.document, false);
    },
  },
  watch: {
    modalVisibility(newValue) {
      if (newValue) {
        this.$refs.caseReconciliationAttachments.show();
      } else {
        this.$refs.caseReconciliationAttachments.close();
      }
    },
    'caseModel': function (value) {
      if (this.modalVisibility && value) {
        this.loading = true;
        this.caseModel.reconciliation.attachmentList.map((attachment) => {
          this.attachmentList.push(attachment);
        });
        this.loading = false;
      } else {
        this.resetData();
      }
    },
  },
  methods: {
    ...mapCasesActions(['getAttachment']),
    closeCaseReconciliationAttachments() {
      this.resetData();
      this.$emit('modalClose');
    },
    resetData() {
      this.attachmentList = [];
      this.selectedReconciliationAttachment = null;
      this.document = null;
      this.loading = false;
    },
    getAttachmentDocument(recAttachment) {
      this.selectedReconciliationAttachment = recAttachment;
      if (!recAttachment.DocumentID) {
        this.document = recAttachment.AttachName;
        return;
      }
      this.loading = true;
      this.getAttachment(recAttachment.DocumentID)
        .then((attachment) => {
          this.document = `data:application/pdf;base64,${attachment.data}`;
        })
        .finally(
          () => (this.loading = false)
        );
    },
  },
};
</script>

<style lang="scss" scoped>
.attachment-file-viewer {
  height: 100%;
  width: 100%;
}
.preview-holder {
  display: block !important;
  height: 600px;
  width: 100%;
}

.pdf-container {
  height: 100%;
  .pdf-wrapper {
    height: 100%;
    position: relative;
    min-height: 150px;
    .pdf-holder {
      height: inherit;
      text-align: center;
      line-height: 1;
      .pdf-viewer {
        max-height: 100%;
        display: inline-block;
      }
    }
  }
}
.attachment-wrapper {
  direction: rtl;
}
embed {
  width: 100%;
  height: 100%;
}
.document-text {
  font-size: 18px;
  line-height: 1.8;
  color: #6d6d6d;
}
</style>